import { render, staticRenderFns } from "./UploadStatement.vue?vue&type=template&id=3babf9ba"
import script from "./UploadStatement.vue?vue&type=script&lang=js"
export * from "./UploadStatement.vue?vue&type=script&lang=js"
import style0 from "./UploadStatement.vue?vue&type=style&index=0&id=3babf9ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports